import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import * as Colors from 'ui-library/Colors';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export enum SaveState {
  SAVING = 'SAVING',
  SAVED = 'SAVED',
  FAILED = 'FAILED',
  UNSAVED = 'UNSAVED',
}

const SAVE_STATE_TO_SAVE_MESSAGE: Record<SaveState, string> = {
  [SaveState.SAVING]: 'Saving...',
  [SaveState.SAVED]: 'Saved',
  [SaveState.FAILED]: 'Saving failed',
  [SaveState.UNSAVED]: 'You have unsaved changes',
};

const SAVE_STATE_TO_ICON: Record<SaveState, () => JSX.Element> = {
  [SaveState.SAVING]: () => (
    <BenchlingDuotoneIcon
      icon="spinner-third"
      primaryColor={Colors.BLUE_LIGHT}
      secondaryColor={Colors.BLUE_POWDER_LIGHT}
      spin={true}
    />
  ),
  [SaveState.SAVED]: () => (
    <BenchlingIcon icon="check-circle" className={css(saveStatusStyles.successIcon)} />
  ),
  [SaveState.FAILED]: () => (
    <BenchlingIcon icon="status-failed" className={css(saveStatusStyles.failedIcon)} />
  ),
  [SaveState.UNSAVED]: () => <BenchlingIcon icon="warning" className={css(saveStatusStyles.warningIcon)} />,
};

export function SaveStatusIndicator(props: {
  saveStatus: SaveState;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <div className={css(saveStatusStyles.body)} {...getTestProps(props.dataTestAttrs)}>
      <div className={css(saveStatusStyles.icon)}>{SAVE_STATE_TO_ICON[props.saveStatus]()}</div>
      <div className={css(saveStatusStyles.saveStatus)}>{SAVE_STATE_TO_SAVE_MESSAGE[props.saveStatus]}</div>
    </div>
  );
}

/** @package */
export const saveStatusStyles = StyleSheet.create({
  body: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  saveStatus: {
    ...FONT_PROXIMA_13,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: Colors.GRAY_DARKER,
  },
  icon: {
    marginRight: '4px',
  },
  successIcon: {
    color: Colors.GRAY_SEMIDARK,
  },
  failedIcon: {
    color: Colors.RED,
  },
  warningIcon: {
    color: Colors.ORANGE,
  },
});
